'use strict';
import Utility from '@/Common/Utility'

var Validator = {
    FirstAttach: true,
    ValidationMessage: "",
    Element: null,
    messageTimer: null,
    i18n: null
};

Validator.Attach = function (elementId) {
    var blockElements;
    var tabIndex = 0;
    var i;


    if (this.FirstAttach) {
        this.FirstAttach = false;
        setTimeout(
            function () {
                this.Attach(elementId);
            }.bind(this),
            1000
        );
    }


    if (elementId != null) {
 
        if (elementId.nodeType == 1) {
            this.Element = elementId;
        }
        else {
            this.Element = document.getElementById(elementId);
        }
    }
    else {
        this.Element = document.body;
    }

    if (this.Element == null) {
        throw ("找不到物件 ID:" + elementId);
    }

 
    blockElements = this.GetElements();

    for (i = 0; i < blockElements.length; i++) {

        if (
            (blockElements[i].getAttribute("ControlType") == "CheckboxList")
            ||
            (blockElements[i].getAttribute("ControlType") == "RadioButtonList")
        ) {



            if (blockElements[i].getAttribute("AlreadyBind") == null) {
                //if (blockElements[i].getAttribute("tabIndex") == null) {
                //    blockElements[i].setAttribute("tabindex", tabIndex++);
                //}

                blockElements[i].addEventListener(
                    "click",
                    this.OnElementChange.bind(this, blockElements[i])
                );

                blockElements[i].setAttribute("AlreadyBind", "true");
            }
        }
        else {


            if (blockElements[i].getAttribute("AlreadyBind") == null) {


                blockElements[i].addEventListener(
                    "change",
                    this.OnElementChange.bind(this)
                );

                blockElements[i].setAttribute("AlreadyBind", "true");
            }
        }
    }


}//end PageUtility.AttachBlock = function (elementId) {


Validator.JoinTagText = function (tagObjects) {
    var tagTexts = [];
    var i;

    for (i = 0; i < tagObjects.length; i++) {
        tagTexts.push(tagObjects[i].text);
    }

    return tagTexts;
}


Validator.GetElements = function () {
    var blockElements = [];
    var allElements;
    var pageElements = new Array();
    var element;
    var i;


    if (this.Element == null) {
        throw ("尚未執行 Attach(elementId) !");
    }

    allElements = this.Element.querySelectorAll("*[nullable] , *[datatype] , *[minlength] , *[maxlength]");

  

    for (i = 0; i < allElements.length; i++) {
        element = allElements[i];



        if (element.type == "radio" && (element.getAttribute("name") + "").indexOf("_option") > 0) {
            continue;
        }


        if (
            (element.parentElement.getAttribute("ControlType") != "CheckboxList")
            &&
            (element.parentElement.getAttribute("ControlType") != "RadioButtonList")
        ) {

            blockElements.push(element);
        }
    }


    return blockElements;
}//end FormBlockControl.prototype.GetElements = function () {



Validator.GetElementDataType = function (element) {
    var dataType = "";

    if ((dataType = element.getAttribute("DataType")) == null) {
        dataType = "String";
    }

    if (dataType == "string") {
        dataType = "String";
    }
    else if (dataType == "int") {
        dataType = "Int";
    }
    else if (dataType == "decimal") {
        dataType = "Decimal";
    }
    else if (dataType == "float") {
        dataType = "Float";
    }
    else if (dataType == "date") {
        dataType = "Date";
    }
    else if (dataType == "datetime") {
        dataType = "DateTime";
    }
    return dataType;
}//end UtilityControl.prototype.GetElementDataType = function (element) {


Validator.AppendValidationMessage = function (message) {
    this.ValidationMessage += message + "\r\n";
},

Validator.ShowMessageInErrorMessageElement = function (nodeElement,message) {
    var errorMessageElement = null;
    var elementTitle = "";
    var elementValue = "";
    var errorMessageElementName = "";
 



    if (window.getComputedStyle(nodeElement).display == "table-cell") {
        if (nodeElement.children.length > 0 &&
            nodeElement.children[nodeElement.children.length - 1].nodeType == 1 &&
            nodeElement.children[nodeElement.children.length - 1].classList.contains("error_message")
        ) {
            errorMessageElement = nodeElement.children[nodeElement.children.length - 1];
        }
    }
    else if (
        nodeElement.nextSibling != null &&
        nodeElement.nextSibling.nodeType == 1 &&
        nodeElement.nextSibling.classList.contains("error_message")
    ) {
        errorMessageElement = nodeElement.nextSibling;
    }

    if (errorMessageElement == null && nodeElement.getAttribute("name") != null) {
        errorMessageElementName = nodeElement.getAttribute("name") + "";

        errorMessageElementName += "_error_message";
        errorMessageElement = document.querySelector(
            "SPAN[name='" + errorMessageElementName + "']"
        );
    }

    if (errorMessageElement == null) {
        if (window.getComputedStyle(nodeElement).display == "table-cell") {
            nodeElement.insertAdjacentHTML("BeforeEnd", "<span class='error_message' ></span>");
            errorMessageElement = nodeElement.lastChild;
        }
        else {
            nodeElement.insertAdjacentHTML("AfterEnd", "<span class='error_message' ></span>");
            errorMessageElement = nodeElement.nextSibling;
        }
    }

    if (nodeElement.getAttribute("title") != null) {
        elementTitle = nodeElement.getAttribute("title");
    }
    else if (nodeElement.getAttribute("placeholder") != null) {
        elementTitle = nodeElement.getAttribute("placeholder");
    }
    else {
        elementTitle = nodeElement.getAttribute("name");
    }


    if (errorMessageElement != null) {
        errorMessageElement.innerHTML = message;
    }
};

Validator.ValidateElement = function (nodeElement) {
    var validated = true;
    var minLength;
    var maxLength;
    var isNullable = true;
    var message = "";
    var maxValue;
    var minValue;
    var dateValue, todayValue, tomorrowValue;
    var today, tomorrow, beginOfToday, beginOfTomorrow;
    var elementNumberValue;
    var errorMessageElementId = "";
    var errorMessageElement = null;
    var fieldSeperatorRegex = /\$/g;
    var emailRegex = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/;
    var alwaysAlertErrorMessage = false;
    var dataType;
    var controlType;
    var elementTitle = "";
    var elementValue = "";
    var singleElementMessage = "";
    var errorMessageElementName = "";
    let nodeValue = null;


    singleElementMessage = ""


   

    if (window.getComputedStyle(nodeElement).display == "table-cell") {
        if (nodeElement.children.length > 0 &&
            nodeElement.children[nodeElement.children.length - 1].nodeType == 1 &&
            nodeElement.children[nodeElement.children.length - 1].classList.contains("error_message")
        ) {
            errorMessageElement = nodeElement.children[nodeElement.children.length - 1];
        }
    }
    else if (
        nodeElement.nextSibling != null &&
        nodeElement.nextSibling.nodeType == 1 &&
        nodeElement.nextSibling.classList.contains("error_message")
    ) {
        errorMessageElement = nodeElement.nextSibling;
    }

    if (errorMessageElement == null && nodeElement.getAttribute("name") != null) {
        errorMessageElementName = nodeElement.getAttribute("name") + "";

        errorMessageElementName += "_error_message";
        errorMessageElement = document.querySelector(
            "SPAN[name='" + errorMessageElementName + "']"
        );
    }

    if (errorMessageElement == null) {
        if (window.getComputedStyle(nodeElement).display == "table-cell") {
            nodeElement.insertAdjacentHTML("BeforeEnd", "<span class='error_message' ></span>");
            errorMessageElement = nodeElement.lastChild;
        }
        else {
            nodeElement.insertAdjacentHTML("AfterEnd", "<span class='error_message' ></span>");
            errorMessageElement = nodeElement.nextSibling;
        }
    } 

    if (nodeElement.getAttribute("title") != null) {
        elementTitle = nodeElement.getAttribute("title");
    }
    else if (nodeElement.getAttribute("placeholder") != null) {
        elementTitle = nodeElement.getAttribute("placeholder");
    }
    else {
        elementTitle = nodeElement.getAttribute("name");
    }

    dataType = this.GetElementDataType(nodeElement);

    elementValue = this.GetElementValue(nodeElement);
 

    isNullable = (nodeElement.getAttribute("Nullable") + "").toLowerCase();

    if (isNullable == "false" || isNullable == false) {
        isNullable = false;
    }
    else {
        isNullable = true;
    }

    if (
        (
            elementValue == null ||
            (elementValue == "" && typeof (elementValue) == "string")
        )
        &&
        !isNullable
    ) {

        if (nodeElement.getAttribute("type") != "hidden") {
            //nodeElement.focus();
            if (errorMessageElement == null) {
                //nodeElement.style.backgroundColor = "red";
            }
        }

        if (elementTitle != "" && elementTitle != null) {
            
            //message = " is required";
            message = " 為必填";

            this.GetElementValue(nodeElement);
        }
        else {
            //message = " required";
            nodeElement.style.border = "1px solid red";
            message = " 必填";
        }

        if (elementTitle != "" &&
            elementTitle != null
        ) {
            message = "'" + elementTitle + "' " + message;
        }

        this.ValidationMessage += message + "\r\n";

        validated = false;
    }
    else {
        if (
            nodeElement.type == "checkbox" &&
            (   nodeElement.getAttribute("nullable") == "false" ||
                nodeElement.getAttribute("nullable") == false
            )
            &&
            nodeElement.checked == false
        ) {
            this.ValidationMessage += "必須勾選 " + elementTitle;
            validated = false;
        }
        else {
            nodeElement.style.backgroundColor = "";
        }
    }

    if (nodeElement.getAttribute("MinLength") != null) {
        minLength = new Number(nodeElement.getAttribute("MinLength"));

        if (!isNullable || nodeElement.value != "") {
            if (nodeElement.value.length < minLength) {
                if (errorMessageElement == null) {
                    nodeElement.style.backgroundColor = "red";
                }

              
                message = ((elementTitle !=null)?"'" + elementTitle + "' ":" ") + "長度必須大於等於 " + minLength;
                 

                this.ValidationMessage += (message + "\r\n");

                validated = false;
            }
            else if (validated) {
                nodeElement.style.backgroundColor = "";
            }
        }
    }


    if (validated && nodeElement.getAttribute("MaxLength") != null) {
        maxLength = new Number(nodeElement.getAttribute("MaxLength"));

        if (!isNullable || (nodeElement.value != "" && nodeElement.value != null)) {


            if (nodeElement.value == null) {
                debugger;
            }

            if (
                nodeElement.value != null &&
                nodeElement.value.length > maxLength) {

                if (errorMessageElement == null) {
                    nodeElement.style.backgroundColor = "red";
                }

                message = ((elementTitle != null) ? "'" + elementTitle + "' " : " ")+"長度必須小於等於 " + maxLength;

                this.ValidationMessage += (message + "\r\n");

                validated = false;
                //return validated;
            }
            else if (validated) {
                nodeElement.style.backgroundColor = "";
            }
        }
    }


    dataType = dataType.toLowerCase();

    //if (validated && nodeElement.tagName == "SPAN") {
    //    return true;
    //}

    if (nodeElement.value != null) {
        nodeValue = nodeElement.value;
    }
    else if (nodeElement.getAttribute("value") != null) {
        nodeValue = nodeElement.getAttribute("value");
    }


    switch (dataType) {
        case "number":
        case "int":
        case "integer":


            if (nodeElement.type == "checkbox" || nodeElement.getAttribute("type") == "checkboxlist") {
                validated = true;
            }
            else if (nodeValue == null) {
                //debugger;
                //Do Nothing 允許 Null
            }
            else if (nodeValue.length > 10) {
                if (errorMessageElement == null) {
                    nodeElement.style.backgroundColor = "red";
                }

                //message = "'" + elementTitle + "' is not a number";
                message = "'" + elementTitle + "' 不是一個數字";
                nodeElement.focus();
                //nodeElement.value = "0";
                this.ValidationMessage += (message + "\r\n");
                validated = false;
            }
            else if (isNaN(nodeValue)) {
                if (errorMessageElement == null) {
                    nodeElement.style.backgroundColor = "red";
                }

                //message = "'" + elementTitle + "' is not a number";
                message = "'" + elementTitle + "' 不是一個數字";

                this.ValidationMessage += (message + "\r\n");

                nodeElement.focus();
                //nodeElement.value = "0";
                validated = false;
            }
            // else if (nodeValue.indexOf(" ") >= 0) {
            //     if (errorMessageElement == null) {
            //         nodeElement.style.backgroundColor = "red";
            //     }

            //     //message = elementTitle + " can not contain space characters";
            //     message = elementTitle + " 不能包含空白字元";
            //     //message = nodeElement.title + " " + ConvertToLanguage("can not contain space character", language);

            //     this.ValidationMessage += (message + "\r\n");

            //     nodeElement.focus();
            //     if (errorMessageElement == null) {
            //         nodeElement.style.backgroundColor = "red";
            //     }
            //     validated = false;
            // }
            else if (nodeElement.getAttribute("data_type") == "int" || nodeElement.getAttribute("data_type") == "integer") {
                if (!IsInteger(new Number(nodeElement.value))) {
                    //message = elementTitle + ConvertToLanguage("is not a integer", language);
                    message = elementTitle + " 不是一個整數"

                    this.ValidationMessage += (message + "\r\n");

                    nodeElement.focus();
                    // nodeElement.value = "0";
                    validated = false;
                }
            }
            else if (validated) {
                nodeElement.style.backgroundColor = "";
            }
            break;

        case "alphanumeric":
            var alphanumericRegex = /^[A-Za-z|0-9|\s|\.]+$/ig;

            if (!nodeValue.match(alphanumericRegex)) {
                if (errorMessageElement == null) {
                    nodeElement.style.backgroundColor = "red";
                }

                //message = ("'" + elementTitle + "' ") + " must be alphanumeric";
                message = ("'" + elementTitle + "' ") + " 必須是英數字";

                this.ValidationMessage += (message + "\r\n");

                nodeElement.value = "";
                nodeElement.focus();

                validated = false;
                break;
            }
            break;

        case "date":
            //if (nodeElement.tagName == "SPAN") {
            //    return true;
            //}
            //else {

            if (nodeElement.value == null) {
                nodeElement.value = nodeElement.getAttribute("value");
            }
            else if (Utility.IsDateObject(nodeElement.value)) {
                validated = true;
                break;
            }

            if (nodeElement.value != null) {

                nodeElement.value = nodeElement.value.replace(/^\s+/g, "");
                nodeElement.value = nodeElement.value.replace(/\s+$/g, "");
            }
            
            //}

 
            if (nodeElement.value != "" && nodeElement.value != null) {

                if (!this.DateValidate(nodeElement.value)) {
                    if (errorMessageElement == null) {
                        nodeElement.style.backgroundColor = "red";
                    }

                    //message = ("'" + nodeElement.value + "' is not valid date");
                    message = ("'" + nodeElement.value + "' 不是一個日期格式");

                    this.ValidationMessage += (message + "\r\n");

                    nodeElement.value = "";
                    //nodeElement.focus();

                    validated = false;
                    break;
                }
                else {
                    nodeElement.style.backgroundColor = "";
                }
            }
            break;


        case "datetime":


            if (nodeElement.value != "" && nodeElement.value != null) {

                if (nodeElement.value != null && Utility.IsDateObject(nodeElement.value)) {
                    validated = true;
                    break;
                }

                nodeElement.value = nodeElement.value.replace(/^\s+/g, "");
                nodeElement.value = nodeElement.value.replace(/\s+$/g, "");

                if (!this.DateTimeValidate(nodeElement.value)) {
                    if (errorMessageElement == null) {
                        nodeElement.style.backgroundColor = "red";
                    }

                    //message = ("'" + nodeElement.value + "' is not valid date time");
                    message = ("'" + nodeElement.value + "' 不是一個日期時間格式");

                    this.ValidationMessage += (message + "\r\n");

                    nodeElement.value = "";
                    //nodeElement.focus();

                    validated = false;
                    break;
                }
                else {
                    nodeElement.style.backgroundColor = "";
                }
            }
            break;


        case "time":
            nodeElement.value = nodeElement.value.replace(/^\s+/g, "");
            nodeElement.value = nodeElement.value.replace(/\s+$/g, "");

            if (nodeElement.value != "" && nodeElement.value != null) {

                if (!this.TimeValidate(nodeElement.value)) {
                    if (errorMessageElement == null) {
                        nodeElement.style.backgroundColor = "red";
                    }

                    //message = ("'" + nodeElement.value + "' is not valid time");
                    message = ("'" + nodeElement.value + "' 不是一個日期時間格式");

                    this.ValidationMessage += (message + "\r\n");

                    nodeElement.value = "";

                    validated = false;
                    break;
                }
                else {
                    nodeElement.style.backgroundColor = "";
                }
            }
            break;

        case "email":
            nodeElement.value = nodeElement.value.replace(/^\s+/g, "");
            nodeElement.value = nodeElement.value.replace(/\s+$/g, "");

            if (
                nodeElement.value != "" &&
                nodeElement.value.search(emailRegex) < 0
            ) {
                if (errorMessageElement == null) {
                    nodeElement.style.backgroundColor = "red";
                }
                //message = "'" + nodeElement.value + "' " + " is not a valid email";
                message = "'" + nodeElement.value + "' " + " 不是一個 Email 格式";

                this.ValidationMessage += (message + "\r\n");

                nodeElement.focus();

                validated = false;
                break;
            }
            else {
                nodeElement.style.backgroundColor = "";
            }
            break;
    }

  


    
    if (
        validated
        &&
        (
            dataType == "number" ||
            dataType == "int" ||
            dataType == "integer"
        )
    ) {
        

        if (!isNullable || nodeValue != "") {
            elementNumberValue = new Number(nodeValue);

            if (nodeElement.getAttribute("MaxValue") != null) {
                maxValue = new Number(nodeElement.getAttribute("MaxValue"));

                if (elementNumberValue > maxValue) {
                    if (errorMessageElement == null) {
                        nodeElement.style.backgroundColor = "red";
                    }

                    //message = "'" + elementTitle + "' " + " can not larger than " + " " + maxValue;
                    message = "'" + elementTitle + "' " + " 不能大於 " + " " + maxValue;
                    this.ValidationMessage += (message + "\r\n");

                    validated = false;
                }
            }

            if (nodeElement.getAttribute("MinValue") != null) {
                minValue = new Number(nodeElement.getAttribute("MinValue"));

                if (elementNumberValue < minValue) {
                    if (errorMessageElement == null) {
                        nodeElement.style.backgroundColor = "red";
                    }

                    //message = "'" + elementTitle + "' " + " can not less than " + " " + minValue;
                    message = "'" + elementTitle + "' " + " 不能小於 " + " " + minValue;

                    this.ValidationMessage += (message + "\r\n");

                    validated = false;
                }
            }

            if (validated) {
                nodeElement.style.backgroundColor = "";
            }
        }
    }
    else if (validated && dataType == "date") {
        if (nodeElement.getAttribute("MinValue") == "today") {
            dateValue = new Date(nodeValue);
            today = new Date();

            todayValue = today.getFullYear() + "/" + (today.getMonth() + 1) + "/" + today.getDate();
            beginOfToday = new Date(todayValue);

            if (dateValue < beginOfToday) {
                if (errorMessageElement == null) {
                    nodeElement.style.backgroundColor = "red";
                }

                //message = "'" + elementTitle + "' " + " can not larger than " + " " + todayValue;
                message = "'" + elementTitle + "' " + " 不能大於 " + " " + todayValue;

                this.ValidationMessage += (message + "\r\n");

                validated = false;
            }
        }
        else if (nodeElement.getAttribute("MinValue") == "tomorrow") {
            dateValue = new Date(nodeValue);
            tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            tomorrowValue = tomorrow.getFullYear() + "/" + (tomorrow.getMonth() + 1) + "/" + tomorrow.getDate();
            beginOfTomorrow = new Date(tomorrowValue);

            if (dateValue < beginOfTomorrow) {
                if (errorMessageElement == null) {
                    nodeElement.style.backgroundColor = "red";
                }

                message = elementTitle + " " + "" + " " + tomorrowValue;

                this.ValidationMessage += (message + "\r\n");

                validated = false;
            }
        }
    }


    singleElementMessage = message;

 
    if (errorMessageElement != null) {
        if (validated) {
      
            errorMessageElement.innerHTML = "";
        }
        else {

            setTimeout(
                function () {
                    errorMessageElement.innerHTML = singleElementMessage;
                },
                100
            );
        }
    }


    return validated;
}



Validator.DateValidate = function (val) {
    var dateRegex = /\d{4}\/\d{1,2}\/\d{1,2}$/;
    var tokens;

    if (!dateRegex.test(val)) {
        return false;
    }
    return true;
}//end Validator.DateValidate = function (val) {


Validator.TimeValidate = function (val) {
    var timeRegex = /\d{1,2}\:\d{1,2}$/;
    var tokens;

    if (!timeRegex.test(val)) {
        return false;
    }
    return true;
}//end Validator.TimeValidate = function (val) {


Validator.DateTimeValidate = function (val) {
    let result;
    let dateTimeObject;


    dateTimeObject = Date.parse(val);

    if (isNaN(dateTimeObject)) {
        result = false;
    }
    else {
        result = true;
    }

    return result;
}//end Validator.DateTimeValidate = function (val) {



Validator.OnElementChange = function (e) {
    var element;
    var validated = true;
 

    if (e.tagName == "DIV") {
        element = e;
    }
    else {
        element = e.target;
    }

    try {
        validated = this.ValidateElement(element);
    }
    catch (ex) {
        throw(ex);
    }

}//end Validator.OnElementChange = function (e) {


Validator.ValidateBlock = function (showValidationMessage,element) {
    var validated = true;
    var blockElements;
    var notValidElementCount = 0;
    var i;

    if (element != null) {
        this.Attach(element);
    }

    blockElements = this.GetElements();

    this.ValidationMessage = "";

    validated = true;

    this.ValidationMessage = "";
 

    for (i = 0; i < blockElements.length; i++) {


 
        if (!this.ValidateElement(blockElements[i])) {
            validated = false;
            notValidElementCount++;

            if (notValidElementCount == 1) {
                blockElements[i].focus();
            }
        }
    }

    if (!validated && showValidationMessage == true) {
        this.ShowValidationMessage();
    }

    return validated;
}//end PageUtility.ValidateBlock = function () {



Validator.ClearBlock = function () {
    let blockElements;
    let i;

    blockElements = this.GetElements();


    for (i = 0; i < blockElements.length; i++) {
        this.SetElementValue(blockElements[i], "");
    }
}

Validator.ClearError = function () {
    let errorElements;

    if (this.Element != null) {

        errorElements = this.Element.querySelectorAll(":scope .error_message");

        if (nodeElement.style.border == "1px solid red") {
            nodeElement.style.border = "";
        }


        errorElements.forEach(
            errorElement => {
                errorElement.innerHTML = "";
            }
        );
    }
}

Validator.SetElementValue = function (element, value) {
    var inputElements;
    var optionElement;
    var inputElements;
    var inputElement;
    var spanElement;
    var elementName;
    var textNode;
    var lastValue, valueTokens;
    var dataType;
    var yyyy, mm, dd;
    var dateObject, dateValue;
    var i;


    elementName = element.getAttribute("name");
    dataType = this.GetElementDataType(element);

    if (element.tagName == "INPUT") {

        if (element.type == "checkbox") {
            if (value == "1" || value == 1 || value == "on" || value == true || value == "true" || value == "Y" || value == "y") {
                element.checked = true;
            }
            else {
                element.checked = false;
            }
        }
        else if (dataType == "Date") {

            if (value != null && value != "") {
                if (typeof (value) == "string") {
                    dateObject = new Date(value);
                }
                else {
                    dateObject = value;
                }

                yyyy = dateObject.getFullYear();
                mm = dateObject.getMonth() + 1; // getMonth() is zero-based
                dd = dateObject.getDate();

                dateValue =
                    yyyy + "/" +
                    (mm > 9 ? '' : '0') + mm + "/" +
                    (dd > 9 ? '' : '0') + dd;

                element.value = dateValue;
            }
            else {
                element.value = "";
            }
        }
        else {
            element.value = value;
        }
    }
    else if (element.tagName == "SELECT") {
        for (i = 0; i < element.length; i++) {
            if (element[i].value != null && element[i].value == value) {
                element[i].selected = true;
            }
            else if (element[i].value == null && element[i].text == value) {
                element[i].selected = true;
            }
            else {
                element[i].selected = false;
            }
        }
    }
    else if (element.tagName == "TEXTAREA") {
        element.value = value;
    }
    else if (element.tagName == "LABEL") {
        element.innerHTML = value;
    }
    else if (element.tagName == "SPAN") {
        element.innerHTML = value;
    }
    else if (element.getAttribute("ControlType") == "CheckboxList") {
        valueTokens = value.split(",");

        inputElements = element.querySelectorAll("INPUT");

        for (i = 0; i < inputElements.length; i++) {
            inputElement = inputElements[i];
            if (valueTokens.indexOf(inputElement.value) >= 0) {
                inputElement.checked = true;
            }
            else {
                inputElement.checked = false;
            }
        }//end for (i = 0 ; i < inputElements.length ; i++) {
    } else if (element.getAttribute("ControlType") == "RadioButtonList") {
        valueTokens = value.split(",");

        inputElements = element.querySelectorAll("INPUT");

        for (i = 0; i < inputElements.length; i++) {
            inputElement = inputElements[i];
            if (inputElement.value == value) {
                inputElement.checked = true;
            }
            else {
                inputElement.checked = false;
            }
        }//end for (i = 0 ; i < inputElements.length ; i++) {
    }
}

Validator.GetElementValue = function (element) {
    var elementValue = "";
    var inputElements, checkedElements = new Array();
    var optionElement;
    var dataType = "";
    var i;


    checkedElements.length = 0;

    if ((dataType = element.getAttribute("DataType")) == null) {
        dataType = "Text";
    }

    if (element.getAttribute("ControlType") == "CheckboxList") {
        inputElements = element.querySelectorAll("INPUT");

        for (i = 0; i < inputElements.length; i++) {
            if (inputElements[i].checked == true) {
                checkedElements.push(inputElements[i]);
            }
        }

        for (i = 0; i < checkedElements.length; i++) {
            elementValue += checkedElements[i].value;

            if (i < checkedElements.length - 1) {
                elementValue += ",";
            }
        }
    }
    else if (element.getAttribute("ControlType") == "RadioButtonList") {
        inputElements = element.querySelectorAll("INPUT");

        for (i = 0; i < inputElements.length; i++) {
            if (inputElements[i].checked == true) {
                elementValue = inputElements[i].value;
                break;
            }
        }
    }
    else if (element.value != null) {
        elementValue = element.value;
    }
    else if (element.getAttribute("value") != null) {
        elementValue = element.getAttribute("value");
    }
    else if (element.tagName == "LABEL") {
        elementValue = element.innerHTML;
    }
    else if (element.tagName == "SPAN") {
        elementValue = element.innerHTML;
    }
    else if (element.tagName == "SELECT") {
        for (i = 0; i < element.length; i++) {
            optionElement = element[i];

            if (optionElement.selected == true) {
                if (optionElement.value != null) {
                    elementValue = optionElement.value;
                }
                else {
                    elementValue = optionElement.innerText;
                }
                break;
            }
        }
    }
    else if ((element.getAttribute("type") + "").toLowerCase() == "checkbox") {
        if (element.checked) {
            elementValue = this.CastValue("1", dataType);
        }
        else {
            elementValue = this.CastValue("0", dataType);
        }
    }

    else {
        if (element.value != null) {
            elementValue = element.value;
        }
        else {
            elementValue = element.getAttribute("value");
        }

        if (elementValue == "") {
            elementValue = null;
        }
    }

    if (elementValue != null) {
        elementValue = this.CastValue(elementValue, dataType);
    }

    return elementValue;
}//end PageUtility.GetElementValue = function (element) {


Validator.CastValue = function (value, dataType) {
    var castedValue = null;

    dataType = dataType.toLowerCase();

    switch (dataType) {
        case "text":
        case "string":
        case "email":
            if (value == null) {
                castedValue = null;
            }
            else {
                castedValue = value + "";
            }
            break;

        case "int":
        case "integer":
            if (typeof (value) == "number") {
                castedValue = value;
            }
            else if (value == "") {
                castedValue = null;
            }
            else {
                castedValue = parseInt(value);
            }
            break;

        case "float":
        case "decimal":
        case "number":
            if (value == "") {
                castedValue = null;
            }
            else {
                castedValue = parseFloat(value);
            }
            break;

        case "date":
            if (value == "" || value == null) {
                castedValue = null;
            }
            else {
                castedValue = new Date(value);
            }
            break;

        case "datetime":
            if (value == "" || value == null) {
                castedValue = null;
            }
            else {
                castedValue = new Date(value);
            }
            break;

        case "time":
        case "month":
            castedValue = value;
            break;

        case "boolean":

            if (typeof (value) == "string") {
                value = value.toLowerCase();
            }

            if (value == 0) {
                castedValue = false;
            }
            else if (value == 1) {
                castedValue = true;
            }
            else if (value == "on") {
                castedValue = true;
            }
            else if (value == "off") {
                castedValue = false;
            }
            else if (value == "true") {
                castedValue = true;
            }
            else if (value == "false") {
                castedValue = false;
            }
            else {
                throw "unknown boolean format '" + value + "'";
            }

            break;

        default:
            if (value == null) {
                return null;
            }
            else {
                throw ("未知的資料型態 " + dataType + " !");

            }
            break;
    }

    return castedValue;
}//end PageUtility.CastValue = function (value, dataType) {



Validator.ShowSaveSuccess = function (duration) {
    let saveSuccessMessage;


    if (this.i18n != null && this.i18n.t != null) {
        saveSuccessMessage = this.i18n.t("Save Success !");
    }
    else {
        saveSuccessMessage = "Save Success !";
    }

    this.ShowMessage(saveSuccessMessage, duration);
}


Validator.ShowValidationMessage = function (duration) {
    if (duration == null) {
        duration = 2000;
    }

    this.ShowMessage("<div class='ValidationMessage' style='color:Red'>" + this.ValidationMessage + "</div>", duration);
}

Validator.ShowErrorMessage = function (message, duration) {
    if (duration == null) {
        duration = 2000;
    }

    this.ShowMessage("<div class='ValidationMessage' style='color:Red'>" + message + "</div>", duration);
}



Validator.ShowError = function (message, duration) {
    if (duration == null) {
        duration = 2000;
    }

    this.ShowMessage("<div style='color:Red'>" + message + "</div>", duration);
}


Validator.ShowMessage = function (message, duration) {
    var messageElement;
    var windowLayout;
    var messageLeft;
    var messageTop;
    var browserHeight;
    var browserWidth;

    try {


        if (duration == null) {
            duration = 1000;
        }

        if (this.messageTimer != null) {
            clearTimeout(this.messageTimer);
        }

        if (typeof (event) == "undefined" || event == null || event.srcElement == null || event.srcElement.tagName == null) {
            windowLayout = this.GetCenterWindowLayout(1, 1);

            messageLeft = windowLayout.X;
            messageTop = windowLayout.Y;

        }
        else {
            windowLayout = this.GetCenterWindowLayout(1, 1);

            messageLeft = windowLayout.X;
            messageTop = windowLayout.Y;
        }


        messageLeft = (document.body.clientWidth / 2);
        messageTop = (this.GetScrollTop() + (this.GetBrowserHeight() / 2));

        if (document.getElementById("MESSAGE_BOX") == null) {
            document.body.insertAdjacentHTML("afterBegin", "<DIV class='MessageBox' ID='MESSAGE_BOX' style='position:absolute;z-index:100;vertical-align:middel;left:" + messageLeft + "px;top:" + messageTop + "px;transform:translateX(-50%);-webkit-transform:translateX(-50%);' class='MessageWindow'></DIV>");
        }

        messageElement = document.getElementById("MESSAGE_BOX");
        messageElement.style.top = messageTop + "px";
        messageElement.style.left = messageLeft + "px";
        messageElement.style.zIndex = 5000;
        messageElement.innerHTML = "<div style='margin-top:10px;margin-bottom:10px;margin-left:10px;margin-right:10px;;text-align:left;font-weight:bold'>" + message + "</div>";

        messageElement.style.display = "block";

        this.messageTimer = setTimeout(
            function () {
                this.HiddenMessage();
            }.bind(this)
            ,
            duration
        );
    }
    catch (e) {
        alert(e);
    }
}


Validator.HiddenMessage = function () {
    var messageElement;

    messageElement = document.getElementById("MESSAGE_BOX");

    messageElement.style.display = "none";

    clearTimeout(this.messageTimer);

    this.messageTimer = null;
}


Validator.CheckLogin = function () {
    let token = "";
    token = localStorage.getItem("token");
    if (token == null || token == 'null') {
        console.log('redirect');
        localStorage.setItem("LastPagePath", window.location.pathname);
        window.location.href = "/Login";
    }
}

Validator.NormalizeDataObject = function (obj) {
    var arrayValue;
    var i;

    for (var property in obj) {
        if (obj[property] != null && Array.isArray(obj[property])) {
            arrayValue = obj[property];
            if (arrayValue.length > 0 && arrayValue[0] == '') {
                arrayValue.splice(0, 1);
            }
        }
    }
}

Validator.TranslateData = function (vueComponent) {

    for (var i in vueComponent.$data) {
        var property;

        property = vueComponent.$data[i];

        if (Array.isArray(property)) {
            for (var j = 0; j < property.length; j++) {
                property[j] = vueComponent.$t(property[j]);
            }
        }
        else {
            vueComponent.$data[i] = vueComponent.$t(property);
        }
    }

}





Validator.ScrollToTop = function () {
    window.scrollTo(0, 0);
}



Validator.GetYoutubeIdFromUrl = function (url) {
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;

    var match = url.match(regExp);

    return (match && match[7].length == 11) ? match[7] : "";
}


Validator.pressedKeyCodeMap = {};

Validator.SetKeyEventHandler = function () {
    this.pressedKeyCodeMap = {};
    document.body.onkeydown = this.OnPageKeyDown;
    document.body.onkeyup = this.OnPageKeyUp;
}

Validator.OnPageKeyDown = function (e) {
    var saveButtonElement;

    this.pressedKeyCodeMap[event.keyCode] = true;


    if (this.pressedKeyCodeMap[17] && this.pressedKeyCodeMap[83]) {

        this.pressedKeyCodeMap[17] = false;
        this.pressedKeyCodeMap[83] = false;

        saveButtonElement = document.querySelector(".Button.Save");
        if (saveButtonElement != null) {
            saveButtonElement.click();
            e.preventDefault();
        }


        return false;
    }
}

Validator.OnPageKeyUp = function (e) {
    this.pressedKeyCodeMap[event.keyCode] = false;
}




Validator.GetCenterWindowLayout = function (width, height) {
    var layout = new WindowLayout();
    //var dualScreenLeft = window.screenLeft != null ? window.screenLeft : screen.left;
    //var dualScreenTop = window.screenTop != null ? window.screenTop : screen.top;
    var browserWidth, browserHeight;

    browserWidth = this.GetBrowserWidth();
    browserHeight = this.GetBrowserHeight();

    //    layout.X = ((screen.width / 2) - (width / 2));
    //    layout.Y = ((screen.height / 2) - (height / 2));

    layout.X = ((browserWidth / 2) - (width / 2));
    layout.Y = ((browserHeight / 2) + this.GetScrollTop() - (height / 2));

    layout.Width = width;
    layout.Height = height;

    return layout;
}


Validator.GetBrowserWidth = function () {
    var width;

    width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    return width;
}

Validator.GetBrowserHeight = function () {
    var height;

    height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

    return height;
}


function WindowLayout() {
    this.X = 0;
    this.Y = 0;
    this.Width = 0;
    this.Height = 0;
}

Validator.ShowLoadingPicture = function () {
    var loadingPictureElement;
    var centerWindowLayout;
    var browserHeight;

    loadingPictureElement = document.getElementById("LoadingPicture");
    if (loadingPictureElement == null) {

        let virtualDirectory = "";;
        let urlPrefix = "";

        if (typeof (AppSettings) != "undefined" && typeof (AppSettings) == "object") {

            if (AppSettings.VirtualDirectory != null && AppSettings.VirtualDirectory != "") {
                virtualDirectory = AppSettings.VirtualDirectory;
                urlPrefix = "/"+ virtualDirectory + "/";
            }
            else {
                virtualDirectory = "";
            }
        }

        document.body.insertAdjacentHTML(
            "BeforeEnd",
            "<img src='" + urlPrefix+"/static/img/Loading.svg' id='LoadingPicture' style='width:50px;position: absolute; display: none;z-index:10000'  />");
        loadingPictureElement = document.getElementById("LoadingPicture");
    }

    browserHeight = this.GetBrowserHeight();

    if (loadingPictureElement != null) {
        loadingPictureElement.style.zIndex = 10000;
        loadingPictureElement.style.position = "absolute";
        loadingPictureElement.style.display = "";
        loadingPictureElement.style.left = (document.body.clientWidth / 2 - 10) + "px";
        loadingPictureElement.style.top = (this.GetScrollTop() + browserHeight / 2) + "px";

    }
}



Validator.HideLoadingPicture = function () {
    var loadingPictureElement;

    loadingPictureElement = document.getElementById("LoadingPicture");
    if (loadingPictureElement != null) {
        loadingPictureElement.style.display = "none";
    }
}





Validator.GetScrollTop = function () {
    var scrollTop = (
        (document.documentElement && document.documentElement.scrollTop) ||
        document.body.scrollTop
    );

    return scrollTop;
}


export default Validator;
